import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'

const RuleHeaderEditor = (props) => { 
    const { formObject, viewData, ...restProps } = props;
    return (
            <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '670px', height: '650px' }}
            contentStyle={{ height: '380px' }}
            formTitle={<FormTitle formObject={formObject} value='Main Detail' />}
            formObject={formObject} >
            <div className="uiEditableContent" id="editor">
                <div className="uiGridColumnTwo">
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="Rule ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className="uiVal" />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Active" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isActive" }} className="" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ruleTitle" }} value="Rule Title" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "ruleTitle" }} className="uiVal uiVal50p" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ruleDocType" }} value="Target Document" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                                    action={{ InputType: "ac", paramName: "parentProfile", acMethod: "RuleDocuments"}}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "startDate" }} value="Date Range From" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="relationSince" className=" "
                                    action={{ InputType: "dp", paramName: "startDate" }} 
                                />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "endDate" }} value="To" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="relationSince" className=" "
                                    action={{ InputType: "dp", paramName: "endDate" }} 
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priceType" }} value="Price Type" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                                    action={{ InputType: "ac", paramName: "priceType", acMethod: "CategoryDetail", acDepCtrl: { dparam: "%dataList.valLDT" } }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                                    action={{ InputType: "ac", paramName: "currency", acMethod: "CurrencyName"}}
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLblInLine"> <sarasTrans value="Transactions Parameters" /></span>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unit" }} value="Unit" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                                    action={{ InputType: "ac", paramName: "unit", acMethod: "CategoryDetail", acDepCtrl: { dparam: "%dataList.valLDT" } }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "location" }} value="Location" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "ac", paramName: "parentProfile", acMethod: "Location"}}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "locationGroup" }} value="Location Group" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "locationGroup" }} className="uiVal uiVal50p" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "tagType" }} value="Tag Type Id" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p"
                                    action={{ InputType: "ac", paramName: "parentProfile", acMethod: "Category"}}
                                />
                            </li>
                            <li>
                                <span className="uiLbl"></span>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "tag" }} value="Tag Id" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal uiVal50p "
                                    action={{ InputType: "ac", paramName: "parentProfile", acMethod: "CategoryDetail", acDepCtrl: { dparam: "#tagType" } }}
                                />
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="uiRow uiSpacer10">
                    <span className="uiLblInLine"><sarasTrans value="Action Parameters" /></span>

                </div>
                <div className="uiGridColumnTwo">
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ruleSeq" }} value="Rule Sequence" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "ruleSeq" }} className="uiVal uiVal50p" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priceFormula" }} value="Price Formula" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" action={{ InputType: "input", paramName: "priceFormula" }} className="uiVal uiVal50p" />
                            </li>
                        </ul>
                    </div>
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "includesTax" }} value="Includes Tax" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "includesTax" }} className="" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isVolatile" }} value="Mark Volatile" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey=''  className="" action={{ InputType: "onOff", paramName: "isVolatile" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "interaction" }} value="Needs Call" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey='' className="" action={{ InputType: "onOff", paramName: "interaction" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "skipIfZero" }} value="Skip If Base Price is 0" />
                                </span>
                                <FormCheckbox formObject={formObject} rowKey='' className="" action={{ InputType: "onOff", paramName: "skipIfZero" }} />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            </FormDialog>
    )
}

export default withView(RuleHeaderEditor, "ruleHeader", "ruleHeader")